import { render, staticRenderFns } from "./ActiveContactsModal.vue?vue&type=template&id=313f8d5c&scoped=true&lang=pug"
import script from "./ActiveContactsModal.vue?vue&type=script&lang=js"
export * from "./ActiveContactsModal.vue?vue&type=script&lang=js"
import style0 from "./ActiveContactsModal.vue?vue&type=style&index=0&id=313f8d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313f8d5c",
  null
  
)

export default component.exports